import { useTranslation } from "react-i18next";
import { Phone, ArrowRight, Zap } from "lucide-react";
import { CONTACT } from "../lib/api";

export default function CTABanner() {
  const { t } = useTranslation();
  return (
    <section data-testid="cta-banner" className="relative bg-[#FF5A1F] overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "repeating-linear-gradient(-45deg, #000 0, #000 2px, transparent 2px, transparent 20px)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-5 md:px-10 py-10 md:py-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 md:gap-10">
        <div className="flex items-start md:items-center gap-4 md:gap-6">
          <div className="w-14 h-14 md:w-16 md:h-16 bg-[#0A1128] flex items-center justify-center shrink-0">
            <Zap className="w-7 h-7 md:w-8 md:h-8 text-[#FF5A1F]" strokeWidth={2.6} />
          </div>
          <div>
            <div className="text-white/90 uppercase tracking-widest font-bold text-[11px] md:text-xs mb-1">
              {t("cta_banner.eyebrow")}
            </div>
            <h3 className="font-display text-2xl md:text-3xl lg:text-4xl text-white leading-tight">
              {t("cta_banner.title")}
            </h3>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto shrink-0">
          <a
            href={`tel:${CONTACT.phone}`}
            data-testid="cta-banner-call"
            className="inline-flex items-center justify-center gap-2 bg-[#0A1128] text-white px-6 py-4 font-black uppercase tracking-wider text-sm md:text-base min-h-[56px] hover:bg-black transition-colors"
          >
            <Phone className="w-5 h-5" /> {t("cta_banner.call", { phone: CONTACT.phoneDisplay })}
          </a>
          <a
            href="#offerte"
            data-testid="cta-banner-quote"
            className="inline-flex items-center justify-center gap-2 bg-white text-[#0A1128] px-6 py-4 font-black uppercase tracking-wider text-sm md:text-base min-h-[56px] hover:bg-[#0A1128] hover:text-white transition-colors"
          >
            {t("cta_banner.quote")} <ArrowRight className="w-5 h-5" />
          </a>
        </div>
      </div>
    </section>
  );
}
